import { Component, Input, OnInit } from '@angular/core';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { AuthService } from 'src/app/services/auth/auth.service';

/**
 * LIQUIDACIÓN · SALUD DE LOS COBROS (6.1b; SAL-04, 06, 09). Los cobros de la cobranza que el control retuvo antes de
 * pagarlos: no entran en la liquidación hasta resolverse. Pagos los corrige y se liberan solos en el control siguiente;
 * si era un falso positivo, la gerente de finanzas o el director lo liberan con motivo (entra en el cierre siguiente).
 */
const CAUSAS: Record<string, [string, string]> = {
  ABONO_HUERFANO: ['Abono sin pago', 'Pagos revisa la aplicación: su pago no existe'],
  CUOTA_NO_EXISTE: ['La cuota no existe', 'Pagos revisa la aplicación: apunta a una cuota que no está'],
  PAGO_NO_VIGENTE: ['Pago anulado o sin conciliar', 'Pagos desconcilia los abonos de un pago anulado, devuelto o en revisión'],
  PAGO_DUPLICADO: ['Pago duplicado', 'Pagos anula el registro repetido (misma referencia, cuenta, monto en Bs y día)'],
  PAGO_SOBREDISTRIBUIDO: ['Pago sobredistribuido', 'Pagos desconcilia y vuelve a aplicar: se aplicó más de lo que se pagó'],
  CUOTA_DE_OTRO_CLIENTE: ['Cuota de otro cliente', 'Pagos aplica el pago a una cuota de su cliente'],
  CUOTA_PAGADA_DE_MAS: ['Cuota pagada de más', 'Pagos revisa las aplicaciones de la cuota: suman más que su monto'],
  OTRO_COMERCIO: ['Comercio distinto al de la venta', 'Revisar a qué comercio pertenece la venta'],
  SIN_COMERCIO: ['Abono sin comercio', 'Revisar a qué comercio pertenece la venta'],
  CONVERSION_BS: ['La conversión de Bs no cuadra', 'Si el pago es correcto (por ejemplo, la tasa con 4 decimales), se libera con motivo'],
  MONTO_NO_POSITIVO: ['Monto cero o negativo', 'Pagos revisa la aplicación'],
  CONCILIADO_SIN_FECHA: ['Conciliado sin fecha', 'Pagos completa la fecha de conciliación'],
};

@Component({
  selector: 'app-liquidacion-salud-cobros',
  templateUrl: './liquidacion-salud-cobros.component.html'
})
export class LiquidacionSaludCobrosComponent implements OnInit {
  @Input() dia = '';

  cargando = false;
  error = '';
  aviso = '';
  p: any = null;
  liberando: string | null = null;
  motivo = '';
  ocupado = false;

  constructor(private liq: LiquidacionService, public _auth: AuthService) { }

  get puedeLiberar(): boolean { return this._auth.hasPermission('liquidacion.salud.liberar'); }

  ngOnInit(): void { this.cargar(); }

  cargar = async (): Promise<void> => {
    this.cargando = true; this.error = '';
    try { this.p = await this.liq.saludCobros(this.dia); }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer la salud de los cobros.'; }
    finally { this.cargando = false; }
  };

  nombreCausa = (c: string): string => (CAUSAS[c] && CAUSAS[c][0]) || c;
  comoSeResuelve = (c: string): string => (CAUSAS[c] && CAUSAS[c][1]) || '';

  liberar = async (c: any): Promise<void> => {
    if (this.motivo.trim().length < 5) { this.error = 'Para liberar escribe el motivo (5 caracteres o más).'; return; }
    this.ocupado = true; this.error = ''; this.aviso = '';
    try {
      await this.liq.liberarCobro(c.abono, this.motivo.trim());
      this.aviso = `El cobro de ${c.venta} quedó liberado: entra en la próxima liquidación de ${c.merchant_code}.`;
      this.liberando = null; this.motivo = '';
      await this.cargar();
    } catch (e: any) { this.error = e?.error?.msg || 'No se pudo liberar.'; }
    finally { this.ocupado = false; }
  };
}
